import React from 'react'
import styled from 'styled-components'
import Notification from '../../components/Notification'
import { useNotificationsDataState } from '../../globalStates/NotificationDataState'

const NotificationsWrapper = styled.div`
    position: absolute;
    padding: 1rem;
    right: 0;
    bottom: 0;
    width: max-content;
    max-width: 100%;
`

const NotificationsContainer: React.FC<{}> = () => {
    const notitifcations = useNotificationsDataState().getNotifications()

    return (
        <NotificationsWrapper>
            {notitifcations.map((notification, index) => <Notification key={index} type={notification.type} title={notification.title} text={notification.text} />)}
        </NotificationsWrapper>
    )
}

export default NotificationsContainer